<template lang="pug">
  .book-list-wrapper
    .book-list-search
      h3 未排期区本
      el-input(
        placeholder="请输入区本号"
        icon="search"
        v-model="searchBookVal")
    vddl-list.book-list.row(
      :list="resultBookList"
      :drop="handleDrop")
      vddl-placeholder.col-sm-6
        .book-item-box 插入
      vddl-draggable.book-item.col-sm-6(
        v-for="(item, index) in resultBookList"
        :key="item.label"
        :draggable="item"
        :index="index"
        :wrapper="resultBookList"
        effect-allowed="move"
        :selected="selectedEvent"
        v-bind:class="{'selected': selected === item}")
        .book-item-box {{item.label}}
</template>

<script>
/**
 * @vue
 */
export default {
  name: 'BookList',
  props: {
    bookList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    /**
     * @param {boolean} 加载抄表员 是否加载完抄表员列表
     */
    return {
      selected: null,
      searchBookVal: ''
    }
  },
  watch: {
    bookList: {
      handler (val, oldVal) {
        this.searchBookVal = ''
      },
      deep: true
    }
  },
  computed: {
    resultBookList () {
      return this.searchBookVal === '' ? this.bookList : this.bookList.filter(({label}) => label.indexOf(this.searchBookVal) >= 0)
    }
  },
  methods: {
    selectedEvent (item) {
      this.selected = item
    },
    handleDrop (data) {
      this.$emit('changeBookList', data)
    }
  }
}
</script>

<style scoped lang="sass">
.book-list-wrapper
  display: flex
  flex-direction: column
  .book-list-search
    h3
      font-size: 20px
      color: #222
  .book-list
    height: 100%
    align-content: baseline
    overflow: auto
.vddl-placeholder
  margin-top: 6px
  border-radius: 5px
  .book-item-box
    cursor: move
    line-height: 24px
    color: #fff
    font-size: 12px
    text-align: center
    border-radius: 5px
    background: #a3d7fb
.vddl-dragging-source
  display: none
.vddl-list, .vddl-draggable
  position: relative
</style>



// WEBPACK FOOTER //
// BookList.vue?3fb51939